import {FormControl, Checkbox, FormGroup, FormControlLabel} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import {useState} from "react";
import { useEffect } from 'react'

const RenderCheckBox = ({ id, name, row, labels, defaultLabel, helperText, vals, onClick = () => {}, input, meta: { touched, error }, ...custom }) => {

  // const [state, setState] = React.useState(vals.reduce((result, categoryName) => {
  //   result[categoryName] = false
  //   return result;
  // },{}));

  const [state, setState] = useState(input.value || 0);
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    console.count("stateChange")
    input.onChange(state);
  },[state])

  // inputの変化を検知しなくても、handleChangeで、setStateしているので不要では? mitateda
  // useEffect(() => {
  //   setState(input.value)
  // },[input])

  return (
    <FormControl>
      <FormGroup row>
        {
          vals.map((value, index) => (
              <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                        name={value}
                        checked={input.value[value] || false} // default値がundefindedになるので、 || false追加
                        onChange={handleChange}
                        onClick={() => onClick()}
                    />
                  }
                  label={labels[index]}
                  {...custom}
              />
          ))
        }
      </FormGroup>
      {
        helperText && (
            <FormHelperText>{helperText}</FormHelperText>
        )
      }
      {
        touched && error && (
            <span className="error">{error}</span>
        )
      }
    </FormControl>
  )
}

export default RenderCheckBox;
